import { addDays } from 'date-fns'
import { formatISODate } from 'shared-utils/date-utils'
import { DAYS_PER_WEEK } from './calendar-grid'

/**
 * Keyboard navigation helpers for calendar component
 */

export const KEY_DIRECTION_MAP: Record<string, number> = {
  ArrowLeft: -1,
  ArrowRight: 1,
  ArrowUp: -DAYS_PER_WEEK,
  ArrowDown: DAYS_PER_WEEK,
}

/**
 * Check if a keyboard event should be ignored
 */
export function shouldIgnoreKeyboardEvent(target: HTMLElement): boolean {
  const nodeName = target.nodeName
  if (nodeName === 'INPUT' || nodeName === 'SELECT') return true
  if (nodeName === 'BUTTON' && !target.dataset?.date) return true
  return false
}

/**
 * Find the next selectable date in a given direction
 */
export function findNextSelectableDate(
  startDate: Date,
  direction: number,
  querySelector: (selector: string) => Element | null,
): Date | null {
  let nextDate = addDays(startDate, direction)
  if (!nextDate) return null

  let el = querySelector(`button[data-date="${formatISODate(nextDate)}"]`)

  // Skip disabled dates
  while (el instanceof HTMLButtonElement && el.dataset.disabled) {
    nextDate = addDays(nextDate, direction)
    el = querySelector(`button[data-date="${formatISODate(nextDate)}"]`)
    if (!el) return null
  }

  return nextDate
}

/**
 * Get the direction for a keyboard event
 */
export function getKeyDirection(key: string): number | null {
  return KEY_DIRECTION_MAP[key] ?? null
}
